export default __webpack_public_path__ + "static/media/undraw_handcrafts_curved_arrow.7b525dfa.svg";